// extracted by mini-css-extract-plugin
export var labelWrapper = "_fg-0";